import http from 'hub-http/clients/apiClient';
import { getObjectType, transformEnrichPayload } from '../../utils';
export async function enrichRecords(context) {
  const {
    enrichmentType,
    objectTypeId,
    selectionIds,
    shouldOverwrite
  } = context;
  const idsKey = `${enrichmentType}Ids`;
  const objectType = getObjectType(objectTypeId);
  const payload = transformEnrichPayload(selectionIds);
  const enrichAssociatedRecords = context.enrichAssociations;
  return await http.post(`enrichment-platform/v2/${objectType}/updates/apply/batch`, {
    data: {
      [idsKey]: payload,
      shouldOverwrite,
      enrichAssociatedRecords
    }
  });
}